<template>
  <div class="container">
    <div class="inside-banner">
      <!-- ElementUI轮播图 -->
      <el-carousel
          class="banner-carousel"
          indicator-position="none"
          loop
          autoplay
          arrow="never"
      >
        <el-carousel-item v-for="(item, index) in topImgList" :key="index">
          <a class="banner-link" href="" target="">
            <img
                :src="item.src"
                :alt="item.title"
                class="carousel-img"
            />
          </a>
        </el-carousel-item>
      </el-carousel>

      <!-- 面包屑 -->
      <div class="crumbs">
        <p>
          <a href="/home" target="">首页</a> /
          <a href="/player" target="">签约球员</a> /
          <a href="" target="">{{formData.name}}</a>
        </p>
      </div>
    </div>

    <div class="container-content">
      <!-- 左侧文章内容 -->
      <div class="fl art-content" v-loading="loading">
        <h1>{{formData.name}}</h1>
        <div class="art-time">
          <span>发布时间：{{formData.time}}</span>
        </div>
        <!-- 富文本内容区域 -->
        <div class="art-body" v-html="formData.content"></div>
        <div class="turn-page">
          <div class="prev-article">上一篇：
            <a v-if="formData.previous"  :href="`/playerDetail?playerId=${formData.previous}`">{{formData.previousName}}</a>
            <a v-else href="">没有了</a>
          </div>
          <div class="next-article">下一篇：
            <a v-if="formData.next"  :href="`/playerDetail?playerId=${formData.next}`">{{formData.nextName}}</a>
            <a v-else href="">没有了</a>
          </div>
          <a v-if="!type" class="back" href="/player" target="">返回列表 ></a>
        </div>
      </div>

      <!-- 右侧相关球员 -->
      <div class="fr relate-news pc-nr">
        <h2>相关球员
<!--          <a href="/player" target="">更多 ></a>-->
        </h2>
        <ul>
          <li v-for="(item, index) in playerList" :key="index">
            <a @click="handPlayerClick(item.id)">
              <p><span>{{item.year}}</span><em>{{item.monthDay}}</em></p>
              <h3>{{ item.name }}</h3>
            </a>
          </li>
        </ul>
<!--        <a class="more" href="" target="">查看更多</a>-->
      </div>
    </div>
  </div>
</template>

<script>
import {getImgList, selectListByPlayer} from "@/api/home";
import {ImageTypeEnum} from "@/enums/imageTypeEnum";

export default {
  name: 'CaseBanner',
  data() {
    return {
      loading: false,
      topImgList:'',
      playerList:[],
      formData:{
        url:'',
        time:'',
        name: '',
        content:'',
        previous:'',
        previousName:'',
        next:'',
        nextName:'',
        playerList:[]
      },
      type: '',
    };
  },
  watch: {
    // 监听路由参数变化，重新获取产品详情
    "$route.query": {
      immediate: true, // 初始化时立即执行
      handler(newQuery) {
        const { playerId,type } = newQuery;
        if(type){
          this.type = type;
        }
        if (playerId) {
          this.selectListByArticle(playerId);
        } else {
          this.$message.warning("球员参数不能为空");
          this.richTextContent = "";
        }
      },
    },
  },
  created() {
    this.getBannerList();
  },
  methods: {
    //获取图片
    async getBannerList() {
      try {
        this.loading = true;
        const res = await getImgList(ImageTypeEnum.PLAYER_DETAIL_BANNER.value);
        const dataList = res.data || [];
        this.topImgList = dataList.filter(item => item.classify === ImageTypeEnum.PLAYER_DETAIL_BANNER.value && item.src);
      } catch (error) {
        console.error("获取轮播图失败：", error);
        this.$message?.error("轮播图加载失败，请稍后重试");
      } finally {
        this.loading = false;
      }
    },
    //根据文章id获取文章详情
    async selectListByArticle(playerId) {
      try {
        this.loading = true;
        const res = await selectListByPlayer(playerId);
        if (res.code === 200) {
          this.formData = res.data ||[];
          this.playerList = this.formData.playerList;
        } else {
          this.$message.error(res.msg || "获取文章详情失败");
        }
      } catch (error) {
        console.error("球员详情请求失败：", error);
        this.$message.error("网络异常，请稍后重试");
      } finally {
        this.loading = false;
      }
    },
    //球员点击事件
    handPlayerClick(id){
      this.$router.push({ path: '/playerDetail', query: { playerId: id } });
    },
  }
}
</script>

<style scoped lang="scss">
// 统一盒模型
*,
*::before,
*::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
// 基础浮动类（兼容旧类名）
.fl { float: left; }
.fr { float: right; }
// 清除浮动
.clearfix::after {
  content: '';
  display: block;
  clear: both;
}

.container{
  position: relative;
  width: 100%;
  max-width: 1920px; // 限制最大宽度，适配大屏
  margin: 0 auto;
}

// Banner容器
.inside-banner {
  position: relative;
  margin-top: 100px;
  width: 100%;
  overflow: hidden;

  @media (max-width: 768px) {
    margin-top: 80px;
  }
  @media (max-width: 480px) {
    margin-top: 60px;
  }
}

// ElementUI轮播图容器样式
.banner-carousel {
  width: 100%;
  height: 280px !important;

  @media (max-width: 768px) {
    height: 200px !important;
  }
  @media (max-width: 480px) {
    height: 150px !important;
  }

  :deep(.el-carousel__container) {
    height: 100%;
  }

  :deep(.el-carousel-item) {
    height: 100%;
  }
}

// 轮播图链接
.banner-link {
  display: block;
  width: 100%;
  height: 100%;
}

// 轮播图图片样式
.carousel-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

// 面包屑容器
.crumbs {
  position: absolute;
  bottom: 38px;
  left: 9%;
  width: 82%;
  padding: 20px 30px;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  z-index: 10;

  @media (max-width: 768px) {
    bottom: 20px;
    left: 5%;
    width: 90%;
    padding: 15px 20px;
  }
  @media (max-width: 480px) {
    bottom: 10px;
    padding: 10px 15px;
  }
}

// 面包屑文本
.crumbs p {
  color: #999;
  font-size: 12px;
  line-height: 20px;

  @media (max-width: 480px) {
    font-size: 11px;
  }
}

// 面包屑链接
.crumbs p a {
  display: inline-block;
  vertical-align: top;
  margin: 0 10px;
  color: #999;
  text-decoration: none;
  transition: color 0.2s ease;

  &:first-child {
    margin-left: 0;
  }

  &:hover {
    color: #000;
  }

  @media (max-width: 480px) {
    margin: 0 5px;
  }
}

// 面包屑h2样式
.crumbs h2 {
  font-size: 30px;
  color: #555;
  margin: 0 0 8px 0;

  @media (max-width: 768px) {
    font-size: 24px;
  }
  @media (max-width: 480px) {
    font-size: 18px;
  }
}

/* 核心：文章+相关新闻布局（Flex实现左右分栏） */
.container-content{
  position: relative;
  max-width: 1600px;
  margin: 0 auto;
  display: flex; // 改为Flex布局，替代浮动
  justify-content: space-between; // 左右分栏，中间留间隙
  align-items: flex-start; // 顶部对齐
  gap: 2%; // 左右栏间隙，避免贴边

  // 移动端适配：换行显示
  @media (max-width: 992px) {
    flex-direction: column;
    gap: 30px;
  }
}

/* 左侧文章内容 */
.art-content{
  width: 72%; // 左侧占72%
  margin-top: 50px;

  // 移动端占100%
  @media (max-width: 992px) {
    width: 100%;
    margin-top: 30px;
  }
}
.art-content h1{
  padding: 20px;
  font-size: 24px;
  line-height: 26px;
  font-weight: bold;
  border-bottom: 1px solid #e5e5e5;
}
.art-time {
  padding: 20px;
}
.art-time span,.art-time em{
  display: inline-block;
  vertical-align: top;
  color: #999;
}
.art-time em{
  margin-left: 20px;
}
.art-time span a{
  font-size: 14px!important;
  color: #999!important;
  float: none!important;
  background-image: none!important;
}

// 富文本内容区域（核心：限制图片宽度）
.art-body{
  padding: 20px;


  // 穿透样式：限制v-html渲染的图片不超宽
  :deep(img) {
    max-width: 100% !important; // 强制不超过容器宽度
    height: auto !important;    // 保持图片比例，避免拉伸
    display: block;             // 清除行内图片的底部间隙
    margin: 0 auto 20px;        // 图片居中 + 底部间距
    object-fit: contain;        // 保证图片完整显示
  }

  :deep(p){
    margin-bottom: 20px;
    font-size: 16px;
    color: #666;
    text-align: justify;
    line-height: 32px;
  }
}

/* 分页区域（修复div样式，替代原有li） */
.turn-page{
  position: relative;
  margin-top: 50px;
  padding: 20px;
  border-top: 1px solid #e5e5e5;
  border-bottom: 1px solid #e5e5e5;

  // 移动端调整
  @media (max-width: 480px) {
    padding: 15px;
  }
}
.turn-page .prev-article,
.turn-page .next-article {
  font-size: 16px;
  color: #666;
  line-height: 32px;
  margin-bottom: 10px; // 上下篇换行间距
}
.turn-page a {
  color: #666;
  text-decoration: none;
  font-size: 16px;
}
.turn-page a:hover {
  color: #d26b6b;
  text-decoration: underline;
}
.turn-page .back{
  position: absolute;
  top: 50%;
  right: 20px;
  width: 150px;
  height: 40px;
  margin-top: -20px;
  line-height: 40px;
  text-align: center;
  font-size: 16px;
  color: #fff;
  background: #d26b6b;
  border-radius: 3px;
  text-decoration: none; // 清除下划线
  &:hover {
    color: #fff;
  }

  // 移动端调整位置
  @media (max-width: 768px) {
    position: static;
    display: block;
    width: 100%;
    margin: 20px auto 0;
  }
}

/* 右侧相关新闻（固定右侧，占25%） */
.relate-news{
  width: 25%; // 右侧占25%
  margin-top: 50px;
  padding: 0 10px 30px;
  background: #fafafa;
  border-radius: 4px; // 轻微圆角，提升视觉

  // 移动端占100%
  @media (max-width: 992px) {
    width: 100%;
    margin-top: 0;
    padding: 0 15px 30px;
  }
}
.relate-news h2{
  height: 60px;
  padding: 0 6px;
  line-height: 60px;
  font-size: 18px;
  color: #666;
  font-weight: bold;
  border-bottom: 1px solid #e5e5e5;
}
.relate-news h2 a{
  float: right;
  color: #999;
  text-decoration: none;
  font-size: 14px;
}
.relate-news h2 a:hover{
  color: #d26b6b;
}
.relate-news ul{
  padding: 0 10px;
  list-style: none; // 清除默认列表样式
}
.relate-news ul li{
  padding: 15px 0;
  overflow: hidden;
  border-bottom: 1px dotted #c8c8c8;
}
.relate-news ul li a {
  display: flex; // 时间+标题横向排列
  align-items: center;
  text-decoration: none; // 清除下划线
}
.relate-news ul li p{
  flex: 0 0 58px; // 固定时间宽度
  margin-right: 15px;
  text-align: center;
}
.relate-news ul li span{
  display: block;
  line-height: 30px;
  background: #d26b6b;
  color: #fff;
  border-radius: 3px 3px 0 0;
}
.relate-news ul li em{
  display: block;
  line-height: 30px;
  background: #efefef;
  color: #b4b4b4;
  border-radius: 0 0 3px 3px;
}
.relate-news ul li h3{
  flex: 1; // 标题占剩余宽度
  color: #999;
  line-height: 20px;
  transition: all 0.3s;
  font-size: 14px; // 调整字体大小，避免溢出
  font-weight: normal; // 取消粗体
}
.relate-news ul li:hover h3{
  color: #333;
}
.relate-news .more {
  display: block;
  width: 80%;
  height: 40px;
  line-height: 40px;
  text-align: center;
  margin: 20px auto 0;
  background: #d26b6b;
  color: #fff;
  border-radius: 3px;
  text-decoration: none;
  transition: background 0.2s ease;
}
.relate-news .more:hover {
  background: #c15a5a;
}
</style>